import { StandardLayout } from 'shared/layout/StandardLayout'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { NextPage } from 'next'
import { PageProps } from 'types/page'
import { DisclosurePage } from 'experiences/disclosure'

const Disclosure: NextPage<PageProps> = ({ metaTags }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<DisclosurePage />
	</StandardLayout>
)

export const getServerSideProps = defaultSSRProps

export default Disclosure
